import * as React from 'react';
import { useEffect, useState } from 'react';
import { authAxios } from 'src/services/AxiosService';
import { IReportingFile } from '../Files/FileContext';
import { IReportingSupportWorkerRequest } from 'src/components/SupportRequests/SupportWorkerRequestContext';

type ContextType = {
  allFiles: IReportingFile[];
  fromDate: Date;
  setFromDate: React.Dispatch<React.SetStateAction<Date>>;
  toDate: Date;
  setToDate: React.Dispatch<React.SetStateAction<Date>>;
  allSupportWorkerRequests: IReportingSupportWorkerRequest[];
  reportGeneratedDate: Date;
};

export const ReportContext = React.createContext<ContextType>({
  allFiles: [],
  fromDate: new Date(),
  setFromDate: () => {},
  toDate: new Date(),
  setToDate: () => {},
  allSupportWorkerRequests: [],
  reportGeneratedDate: new Date(),
});

export const ReportProvider = (props: any) => {
  const [allFiles, setAllFiles] = useState<IReportingFile[]>([]);
  const [allSupportWorkerRequests, setAllSupportWorkerRequests] = useState<IReportingSupportWorkerRequest[]>([]);
  const defaultFromDate = new Date();
  const [fromDate, setFromDate] = useState<Date>(
    new Date(defaultFromDate.getMonth() < 3 ? defaultFromDate.getFullYear() - 1 : defaultFromDate.getFullYear(), 3, 1)
  );
  const defaultToDate = new Date();
  defaultToDate.setUTCHours(23, 59, 59, 999);
  const [toDate, setToDate] = useState<Date>(defaultToDate);
  const [reportGeneratedDate, setReportGeneratedDate] = useState<Date>(new Date());

  useEffect(() => {
    authAxios.get('/api/files/reporting').then((response) => {
      setAllFiles(response.data);
      setReportGeneratedDate(new Date());
    });
  }, []);

  useEffect(() => {
    authAxios.get('/api/support-worker-requests/admin/reporting').then((response) => {
      setAllSupportWorkerRequests(response.data);
    });
  }, []);

  return (
    <ReportContext.Provider
      value={{
        allFiles,
        fromDate,
        setFromDate,
        toDate,
        setToDate,
        allSupportWorkerRequests,
        reportGeneratedDate,
      }}
    >
      {props.children}
    </ReportContext.Provider>
  );
};

export const ReportConsumer = ReportContext.Consumer;
